import { useEffect, useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { api } from "@/lib/api";
import { PageHeader, Panel } from "@/components/ui-kit";
import { AmazonBulkPanel } from "@/components/sap/AmazonBulkPanel";
import { ShorrPanel } from "@/components/sap/ShorrPanel";
import { DelhaizePanel } from "@/components/sap/DelhaizePanel";
import { McdPanel } from "@/components/sap/McdPanel";
import { NonEdiForm, useNonEdiData } from "@/components/sap/NonEdiForm";

const OWN = { AMAZON: AmazonBulkPanel, SHORR: ShorrPanel, DELHAIZE: DelhaizePanel };

const ManualTab = ({ codes }) => {
  const d = useNonEdiData();
  return (
    <Panel title="Manual order entry" testId="uploads-manual-panel">
      <div className="p-5"><NonEdiForm {...d} partners={d.partners.filter((p) => codes.includes(p.code))} /></div>
    </Panel>
  );
};

export default function Uploads() {
  const [tabs, setTabs] = useState(null);
  useEffect(() => {
    Promise.all([api.get("/my/summary"), api.get("/mcd/partners")]).then(([s, m]) => {
      const mine = s.data.customers;
      const mcd = m.data.map((x) => x.code);
      const t = mine.filter((c) => OWN[c.code]).map((c) => ({ key: c.code, label: c.name, el: OWN[c.code] }));
      if (mine.some((c) => mcd.includes(c.code))) t.push({ key: "MCD", label: "McDonald's distributors", el: McdPanel });
      const rest = mine.filter((c) => !OWN[c.code] && !mcd.includes(c.code)).map((c) => c.code);
      if (rest.length) t.push({ key: "MANUAL", label: "Other customers (manual entry)", el: () => <ManualTab codes={rest} /> });
      setTabs(t);
    });
  }, []);
  if (!tabs) return null;
  return (
    <div>
      <PageHeader title="Upload POs" subtitle="Upload customer POs, check them, fix any missing details and approve to create the SAP IDoc. Only the customers assigned to you are shown." />
      {!tabs.length ? <p className="text-sm text-slate-400" data-testid="uploads-none">No customers are assigned to you yet - ask an administrator.</p> : (
        <Tabs defaultValue={tabs[0].key}>
          <TabsList className="flex h-auto flex-wrap justify-start" data-testid="uploads-tabs">
            {tabs.map((t) => <TabsTrigger key={t.key} value={t.key} data-testid={`uploads-tab-${t.key}`}>{t.label}</TabsTrigger>)}
          </TabsList>
          {tabs.map((t) => <TabsContent key={t.key} value={t.key} className="space-y-4"><t.el /></TabsContent>)}
        </Tabs>)}
    </div>
  );
}
